<template>
    <div>
        <v-dialog v-model="commentsDialog" max-width="700px">
          <v-card>
            <v-card-title class="dialog-header">
                <span v-if="formData.sectionname === 'Comments' || 'Scorable Section'">{{ isEditComments ? $t('pmreviewexercisesectioncard.editcomments') : $t('pmreviewexercisesectioncard.addcomments') }}</span>
                <span v-else-if="formData.sectionname === 'Training Recommendations'">{{ isEditComments ? $t('pmreviewexercisesectioncard.edittrainningrecom') : $t('pmreviewexercisesectioncard.addtrainningrecom') }}</span>
                <span v-else-if="formData.sectionname === 'Movement Recommendations'">{{ isEditComments ?  $t('pmreviewexercisesectioncard.editmovrecom'): $t('pmreviewexercisesectioncard.addmovrecom') }}</span>
            </v-card-title>
            <v-card-text>
              <v-container class="pa-0 pt-3">
                    <div v-if="formData.sectionname === 'Comments'" >
                        <!-- <v-row class="mt-2">
                            <v-col cols="12" class="">
                                <v-autocomplete
                                    outlined
                                    :rules="[rules.required]"
                                    :label="$t('pmreviewexercisesectioncard.commenter')"
                                    type="text"
                                    :items="staffList"
                                    hide-selected
                                    :readonly="isEditComments"
                                    :background-color="isEditComments ? '#ffeab2' : undefined"
                                    v-model="commentsData.staffid"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8" justify="space-between" align="center">
                            <v-col cols="5" class="">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="commentsData.staffcode"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5" class="">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="commentsData.staffcompany"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row> -->
                        <v-row class="mt-2">
                            <v-col cols="12" class="">
                                <v-textarea
                                    outlined
                                    :label="$t('performancemanagement.comments')"
                                    type="textarea"
                                    :rules="[rules.required]"
                                    v-model="commentsData.comment"
                                    rows="2" 
                                    style="resize: vertical;" 
                                    ></v-textarea>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-else-if="formData.sectionname === 'Training Recommendations'" >
                        <v-row class="mt-2">
                            <v-col cols="12" class="">
                                <v-text-field
                                    outlined
                                    :rules="[rules.required]"
                                    :label="isEditComments ? $t('pmreviewexercisesectioncard.coursename') : $t('pmreviewexercisesectioncard.coursenameeditable')"
                                    type="text"
                                    :readonly="isEditComments"
                                    background-color="#ffeab2"
                                    v-model="trainData.coursename"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8">
                            <v-col cols="6" class="">
                                <v-autocomplete
                                    outlined
                                    :label="$t('columns.priority')"
                                    type="text"
                                    ref="priorityid"
                                    :rules="[rules.required]"
                                    v-model="trainData.priority"
                                    :items="priorityList"
                                    dense
                                    ></v-autocomplete>
                            </v-col>
                            <!-- Don't allow to add priority for SS -->
                            <!-- <v-col cols="2" sm="2" class="">
                                <v-dialog v-model="priorityDialog" max-width="500px" persistent>
                                    <template v-slot:activator="{ on }">
                                        <v-btn dense v-on="on">
                                            <v-icon>edit</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <app-genericform 
                                            v-bind:parentData = "{
                                                tabItems: priorityItems,
                                                formTitle: `Priority`,
                                                formId: 'priority'
                                            }"
                                            v-on:input="itemData = $event"
                                            v-on:savePriority="savePriorityHandler"
                                            v-on:deletePriority="deletePriorityHandler($event)"
                                        />

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn
                                                color="warning"
                                                text
                                                @click="priorityDialog = false"
                                            >
                                            {{$t('button.close')}}
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                            </v-col> -->
                        </v-row>
                        <v-row class="mt-n8">
                            <v-col cols="12" class="">
                                <v-textarea
                                    outlined
                                    :label="$t('payeeinputprocess.justification')"
                                    type="textarea"
                                    :rules="[rules.required]"
                                    v-model="trainData.justification"
                                    rows="2" 
                                    style="resize: vertical;" 
                                    ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8">
                            <v-col cols="12" class="">
                                <v-textarea
                                    outlined
                                    :label="$t('columns.remark')"
                                    type="textarea"
                                    :rules="[rules.required]"
                                    v-model="trainData.remark"
                                    rows="2" 
                                    style="resize: vertical;" 
                                    ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="11" sm="11" class="pb-n5 mt-n8">
                            <v-file-input 
                                ref="attach"
                                :label="trainData.attach ? $t('columns.reference')+': ' + trainData.attachname : $t('pmselfservice.nofileselected')" 
                                outlined 
                                v-model="fileHolder"
                                @change="fileToBase64('trainData')"
                                dense
                                >
                            </v-file-input>
                            </v-col>
                        </v-row>

                        <div v-if="isEditComments">
                            <v-row>
                                <v-col cols="4" sm="6" class="ml-1 mt-n5">
                                    <p>
                                        <a v-bind:href="this.trainData.attach"  v-bind:download="this.trainData.attachname" style="font-size: 0.75rem;">
                                            {{trainData.attachname}}
                                        </a>
                                        <v-icon
                                            small
                                            class="ml-3 mr-2"
                                            @click="deleteItemHandler('trainData')"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
                    <div v-else-if="formData.sectionname === 'Movement Recommendations'" >
                        <v-row class="mt-2">
                            <v-col cols="12" class="">
                                <v-text-field
                                    outlined
                                    :rules="[rules.required]"
                                    :label="isEditComments ? $t('pmreviewexercisesectioncard.proposal') : $t('pmreviewexercisesectioncard.proposaleditable')"
                                    type="text"
                                    :readonly="isEditComments"
                                    background-color="#ffeab2"
                                    v-model="movData.proposal"
                                    dense
                                ></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8">
                            <v-col cols="12" class="">
                                <v-textarea
                                    outlined
                                    :label="$t('payeeinputprocess.justification')"
                                    type="textarea"
                                    :rules="[rules.required]"
                                    v-model="movData.justification"
                                    rows="2" 
                                    style="resize: vertical;" 
                                    ></v-textarea>
                            </v-col>
                        </v-row>
                    </div>
                    <div v-if="formData.sectionname === 'Scorable Section'" >
                        <!-- <v-row class="mt-2">
                            <v-col cols="12" class="">
                                <v-autocomplete
                                    outlined
                                    :rules="[rules.required]"
                                    :label="$t('pmreviewexercisesectioncard.commenter')"
                                    type="text"
                                    :items="staffList"
                                    hide-selected
                                    :readonly="isEditComments"
                                    :background-color="isEditComments ? '#ffeab2' : undefined"
                                    v-model="scorableCommentsData.staffid"
                                    dense
                                ></v-autocomplete>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n8" justify="space-between" align="center">
                            <v-col cols="5" class="">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.staffno')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="scorableCommentsData.staffcode"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                            <v-col cols="5" class="">
                                <v-text-field
                                    outlined
                                    :label="$t('columns.company')"
                                    type="text"
                                    :rules="[rules.required]"
                                    v-model="scorableCommentsData.staffcompany"
                                    dense
                                    readonly
                                    background-color="#ffeab2"
                                ></v-text-field>
                            </v-col>
                        </v-row> -->
                        <v-row class="mt-2">
                            <v-col cols="12" class="">
                                <v-textarea
                                    outlined
                                    :label="$t('columns.comment')"
                                    type="textarea"
                                    :rules="[rules.required]"
                                    v-model="scorableCommentsData.comment"
                                    rows="2" 
                                    style="resize: vertical;" 
                                    ></v-textarea>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="11" sm="11" class="pb-n5 mt-n8">
                            <v-file-input 
                                ref="attach"
                                :label="scorableCommentsData.attach ? 'Reference: ' + scorableCommentsData.attachname : 'No file selected'" 
                                outlined 
                                v-model="fileHolder"
                                @change="fileToBase64('scorableCommentsData')"
                                dense
                                >
                            </v-file-input>
                            </v-col>
                        </v-row>

                        <div v-if="isEditComments">
                            <v-row>
                                <v-col cols="4" sm="6" class="ml-1 mt-n5">
                                    <p>
                                        <a v-bind:href="this.scorableCommentsData.attach"  v-bind:download="this.scorableCommentsData.attachname" style="font-size: 0.75rem;">
                                            {{scorableCommentsData.attachname}}
                                        </a>
                                        <v-icon
                                            small
                                            class="ml-3 mr-2"
                                            @click="deleteItemHandler('scorableCommentsData')"
                                        >
                                            mdi-delete
                                        </v-icon>
                                    </p>
                                </v-col>
                            </v-row>
                        </div>
                    </div>
              </v-container>
            </v-card-text>

            <v-card-text v-if="isErr" class="mt-n12">
                <span style="font-weight: bold; color: red">{{errMsg}}</span>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn v-if="isEditComments" color="yellow darken-1" text @click="deleteHandler">{{$t('button.delete')}}</v-btn>
              <v-btn color="green darken-1" text @click="saveHandler">{{$t('button.save')}}</v-btn>
              <v-btn color="red darken-1" text @click="cancelHandler">{{$t('button.cancel')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

        <div v-if="!((formData.sectionname === 'Scorable Section' && itemsList.length < 1) || 
             (formData.sectionname === 'Objective' && indKPIList.length < 1 && cmmKPIList.length < 1))">
            <v-expansion-panels class="mb-6" v-model="panelOpen">
                <v-expansion-panel>
                <v-expansion-panel-header style="background-color: #F1F5F9; min-height: 56px; padding: 12px 16px;">
                    <div class="section-header-inner">
                        <span class="section-title">{{ formData.sectionname }}</span>
                        <span v-if="formData.sectionname === 'Objective' || formData.sectionname === 'Scorable Section'" class="section-stats">
                            <span class="stat-item">
                                <span class="stat-label">{{$t('pmreviewexercisesectioncard.weightage')}}</span>
                                <span class="stat-value">{{ formData.sectweightage }}%</span>
                            </span>
                            <span class="stat-item">
                                <span class="stat-label">{{$t('pmreviewexercisesectioncard.sectionscore')}}</span>
                                <span class="stat-value">{{ formData.sectionScore }} / {{ parseFloat(formData.sectmaxscore || 0).toFixed(2) }}<span v-if="formData.weightingunit === 'P'">%</span></span>
                            </span>
                        </span>
                    </div>
                </v-expansion-panel-header>
                <!-- Objective Section -->
                <v-expansion-panel-content v-if="formData.sectionname == 'Objective'">
                    <!-- <div style="font-size: 0.9rem; margin-top: 15px; width: 100%; padding: 8px 16px;">
                        This is a small description that covers the full width of the panel and is a bit lower.
                    </div> -->
                    <span style="color:#4467C4; margin-top: 6px; margin-bottom: 2px; font-size: 0.88rem; font-weight: 600; letter-spacing: normal; display:block;">{{ formData.sectname }}</span>
                    <p style="margin-bottom:2px; margin-top:2px; font-size:0.82rem; color:#555; font-weight:normal; letter-spacing:normal;">{{ formData.description }}</p>
                    <span style="color:#4467C4; margin-bottom:2px; margin-top:16px; font-size:0.88rem; font-weight:600; letter-spacing:normal; display:block;">{{$t('pmreviewexercisesectioncard.individualkpi')}}</span>
                    <v-expansion-panels multiple :value="allPanelValues">
                        <v-expansion-panel v-for="(item, index) in indKPIList" :key="index">
                            <!-- Header Section -->
                            <v-expansion-panel-header>
                                <div style="display:flex;justify-content:space-between;align-items:center;width:100%;padding-right:8px;">
                                    <h5 style="color:#1a3a5c;margin:0;font-weight:600;">{{ item.goal }}</h5>
                                    <span style="font-size:0.75rem;color:#546e7a;white-space:nowrap;margin-left:12px;">
                                        <span style="font-weight:600;">{{$t('pmreviewexercisesectioncard.weightage')}}</span>
                                        <span style="font-size:1rem;font-weight:700;color:#1a3a5c;margin-left:4px;">{{ item.weightage }}%</span>
                                    </span>
                                </div>
                            </v-expansion-panel-header>

                            <!-- Content Section -->
                            <v-expansion-panel-content>
                                <!-- KPI Details -->
                                <v-row class="ml-0">
                                    <v-col cols="9" class="pl-0 pb-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.goal')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.goal"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-0" style="margin-top:-15px;">
                                    <v-col cols="9" class="pl-0 pb-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.KPI')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.kpi"
                                            readonly
                                            background-color="#ffeab2"
                                            style="height: 60px; padding-bottom: 50px;"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-0" style="margin-top: 15px;">
                                    <!-- First Column -->
                                    <v-col v-if="item.threshold" cols="2" sm="2" class="pb-0 pt-2 ml-0 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.threshold')"
                                            type="text"
                                            ref="type1"
                                            :rules="[rules.required]"
                                            v-model="item.threshold"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>

                                    <!-- Second Column -->
                                    <v-col cols="2" sm="2" class="pb-0 pt-2 ml-0 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('columns.target')"
                                            type="text"
                                            ref="type2"
                                            :rules="[rules.required]"
                                            v-model="item.target"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>

                                    <!-- Third Column -->
                                    <v-col v-if="item.stretch" cols="2" sm="2" class="pb-0 pt-2 ml-0 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.stretch')"
                                            type="text"
                                            ref="type3"
                                            :rules="[rules.required]"
                                            v-model="item.stretch"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>

                                <!-- Progress Review Section -->
                                <v-row class="mt-0 ml-0">
                                    <v-col cols="3" class="pl-0 pb-1">
                                        <span style="color:#4467C4; font-size:0.88rem; font-weight:600; letter-spacing:normal; display:block;">{{$t('pmreviewexercisesectioncard.progressreview')}}</span>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" class="pl-4 pb-1 pr-5">
                                        <template v-if="item.progressReviewList && item.progressReviewList.length > 0">
                                            <v-expansion-panels multiple :value="allPanelValues" style="margin-bottom:10px;">
                                            <v-expansion-panel v-for="(review, reviewIndex) in item.progressReviewList"
                                                :key="reviewIndex">
                                            <v-expansion-panel-header>
                                                <v-row class="ml-0">
                                                    <v-col cols="9" class="pl-0">
                                                        <h5 style="color:#1a3a5c; font-size:0.82rem; font-weight:600; letter-spacing:normal;" ><span v-if="review.isGenerated == 1" style="margin-right: 4px;">*</span>{{ review.reviewdate }} - {{ review.psnname }}</h5>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                            <!-- Progress Review Card -->
                                            <v-row class="align-stretch" style="margin-bottom:0; margin-top:4px;">
                                                <v-col cols="6">
                                                    <v-card outlined elevation="2" class="ml-4 mt-2 mb-2 pa-3 equal-height-card">
                                                        <v-row align="start" class="d-flex">
                                                            <v-col cols="4" class="pr-2">
                                                                <div>{{$t('pmreviewexercisesectioncard.reviewdate')}}</div>
                                                                <div>{{$t('pmreviewexercisesectioncard.reviewedby')}}</div>
                                                                <div>{{$t('pmreviewexercisesectioncard.achievement')}}</div>
                                                                <div>{{$t('pmreviewexercisesectioncard.progressInPercentage')}}</div>
                                                                <div>{{ $t('recstaffdetails.attachment') }}</div>
                                                            </v-col>
                                                            <v-col cols="8" class="pl-2 pr-2">
                                                                <div><b>{{ review.reviewdate || 'N/A' }}</b></div>
                                                                <div><b>{{ review.psnname || 'N/A' }} - {{ review.staffcode || 'N/A' }}</b></div>
                                                                <div><b>{{ review.achievement || 'N/A' }}</b></div>
                                                                <div><b>{{ review.progress || 'N/A' }}%</b></div>
                                                                <div>
                                                                    <p style="font-size: 0.75rem;"> 
                                                                    <a v-bind:href="review.attach"  v-bind:download="review.attachname">
                                                                        {{review.attachname}}
                                                                    </a>
                                                                    </p>
                                                                </div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-card>
                                                </v-col>

                                                <!-- Comments Card -->
                                                <v-col cols="6">
                                                    <v-card outlined elevation="2" class="mt-2 mb-2 mr-4 pa-3 equal-height-card">
                                                        <template v-if="progressReviewCommentList.some(comment => comment.kpiexerindkpiprgid === review.id)">
                                                            <v-row
                                                                dense
                                                                v-for="(comment, commentIndex) in progressReviewCommentList.filter(comment => comment.kpiexerindkpiprgid === review.id)"
                                                                :key="commentIndex"
                                                                style="margin-bottom: 0px;"
                                                            >
                                                                <v-col cols="12" class="py-1 px-0">
                                                                    <div>
                                                                        <b>{{ comment.staffcode }} {{ comment.psnname }}</b> - {{ comment.comments || $t('pmreviewexercisesectioncard.nocomments') }}
                                                                    </div>
                                                                </v-col>
                                                            </v-row>
                                                        </template>
                                                        <template v-else>
                                                            <v-row dense style="margin-bottom: 0px;">
                                                                <v-col cols="12" class="py-1 px-0">
                                                                    <div>{{ $t('pmreviewexercisesectioncard.nocomments') }}</div>
                                                                </v-col>
                                                            </v-row>
                                                        </template>
                                                    </v-card>
                                                </v-col>
                                            </v-row>
                                            </v-expansion-panel-content>
                                            </v-expansion-panel>
                                            </v-expansion-panels>
                                        </template>
                                        <template v-else>
                                            <div>{{$t('pmreviewexercisesectioncard.noprogressionreview')}}</div>
                                        </template>
                                    </v-col>
                                </v-row>

                                <!-- Rating and Score Section -->
                                <div class="item-stat-bar">
                                    <div class="item-stat">
                                        <span class="item-stat-label">{{$t('pmselfservice.itemrating')}}</span>
                                        <span class="item-stat-value highlight">{{ item.rating }}</span>
                                    </div>
                                    <div class="item-stat">
                                        <span class="item-stat-label">{{$t('pmselfservice.itemscore')}}</span>
                                        <span class="item-stat-value highlight">{{ item.score }}</span>
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <span style="color:#4467C4; margin-bottom:2px; margin-top:16px; font-size:0.88rem; font-weight:600; letter-spacing:normal; display:block;">{{$t('pmreviewexercisesectioncard.commonkpi')}}</span>
                    <v-expansion-panels multiple :value="allPanelValues">
                        <v-expansion-panel v-for="(item, index) in cmmKPIList" :key="index">
                            <!-- Panel Header -->
                            <v-expansion-panel-header>
                                <div style="display:flex;justify-content:space-between;align-items:center;width:100%;padding-right:8px;">
                                    <h5 style="color:#1a3a5c;margin:0;font-weight:600;">{{ item.goal }}</h5>
                                    <span style="font-size:0.75rem;color:#546e7a;white-space:nowrap;margin-left:12px;">
                                        <span style="font-weight:600;">{{$t('pmreviewexercisesectioncard.weightage')}}</span>
                                        <span style="font-size:1rem;font-weight:700;color:#1a3a5c;margin-left:4px;">{{ item.weightage }}%</span>
                                    </span>
                                </div>
                            </v-expansion-panel-header>

                            <!-- Panel Content -->
                            <v-expansion-panel-content>
                                <v-row class="ml-0">
                                    <v-col cols="3" class="pl-0 pb-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('columns.type')"
                                            type="text"
                                            :value="'Company'"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-0" style="margin-top:-15px;">
                                    <v-col cols="9" class="pl-0 pb-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.goal')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.goal"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-0" style="margin-top:-15px;">
                                    <v-col cols="9" class="pl-0 pb-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.KPI')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.kpi"
                                            readonly
                                            background-color="#ffeab2"
                                            style="height: 60px; padding-bottom: 50px;" 
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-0" style="margin-top: 15px;">
                                    <v-col v-if="item.threshold" cols="2" sm="2" class="pb-0 pt-2 ml-0 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.threshold')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.threshold"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2" sm="2" class="pb-0 pt-2 ml-0 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('columns.target')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.target"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col v-if="item.stretch" cols="2" sm="2" class="pb-0 pt-2 ml-0 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.stretch')"
                                            type="text"
                                            :rules="[rules.required]"
                                            v-model="item.stretch"
                                            dense
                                            readonly
                                            background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <!-- Rating and Score Section -->
                                <div class="item-stat-bar">
                                    <div class="item-stat">
                                        <span class="item-stat-label">{{$t('pmreviewexercisesectioncard.progress')}}</span>
                                        <span class="item-stat-value">{{ item.progress }}%</span>
                                    </div>
                                    <div class="item-stat">
                                        <span class="item-stat-label">{{$t('pmselfservice.itemrating')}}</span>
                                        <span class="item-stat-value highlight">{{ item.rating }}</span>
                                    </div>
                                    <div class="item-stat">
                                        <span class="item-stat-label">{{$t('pmselfservice.itemscore')}}</span>
                                        <span class="item-stat-value highlight">{{ item.score }}</span>
                                    </div>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-expansion-panel-content>

                <!-- Scorable Section -->
                <v-expansion-panel-content v-if="formData.sectionname == 'Scorable Section'">
                    <!-- <div style="font-size: 0.9rem; margin-top: 15px; width: 100%; padding: 8px 16px;">
                        This is a small description that covers the full width of the panel and is a bit lower.
                    </div> -->
                    <span style="color:#4467C4; margin-top: 6px; margin-bottom: 2px; font-size: 0.88rem; font-weight: 600; letter-spacing: normal; display:block;">{{ formData.sectname }}</span>
                    <p style="margin-bottom:2px; margin-top:2px; font-size:0.82rem; color:#555; font-weight:normal; letter-spacing:normal;">{{ formData.description }}</p>
                    <span style="color:#4467C4; margin-bottom:2px; margin-top:16px; font-size:0.88rem; font-weight:600; letter-spacing:normal; display:block;">{{$t('columns.items')}}</span>
                    <v-expansion-panels multiple :value="allPanelValues">
                        <v-expansion-panel v-for="(item, index) in itemsList" :key="index">
                            <!-- Header Section -->
                            <v-expansion-panel-header>
                                <div style="display:flex;justify-content:space-between;align-items:center;width:100%;padding-right:8px;">
                                    <h5 style="color:#1a3a5c;margin:0;font-weight:600;">{{ item.label }}</h5>
                                    <div style="display:flex;align-items:center;gap:16px;margin-left:12px;">
                                        <span style="font-size:0.75rem;color:#546e7a;white-space:nowrap;">
                                            <span style="font-weight:600;">{{$t('pmreviewexercisesectioncard.rating')}}</span>
                                            <span style="font-size:1rem;font-weight:700;color:#1a3a5c;margin-left:4px;">{{ item.scorableRating }}</span>
                                        </span>
                                        <span style="font-size:0.75rem;color:#546e7a;white-space:nowrap;">
                                            <span style="font-weight:600;">{{$t('pmreviewexercisesectioncard.weightage')}}</span>
                                            <span style="font-size:1rem;font-weight:700;color:#1a3a5c;margin-left:4px;">{{ item.weightage }}%</span>
                                        </span>
                                    </div>
                                </div>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <!-- Description -->
                                <v-row class="ml-0">
                                    <v-col cols="12" class="pl-2 pb-0 pt-1">
                                        <div style="font-size:0.82rem;color:#555;font-weight:normal;letter-spacing:normal;">{{ item.description }}</div>
                                    </v-col>
                                </v-row>
                                <v-row v-if="formData.ratingset" class="ml-0 mt-3">
                                    <!-- Table Section (Left) -->
                                    <v-col cols="12" class="pl-0 pb-0">
                                        <v-card outlined elevation="2">
                                            <v-row class="d-flex align-center" style="margin: 0; padding: 0;">
                                                <v-col cols="12">
                                                    <v-radio-group v-model="item.scorableRating" @change="onRatingChange(item)" :disabled="isReadOnly">
                                                        <v-row 
                                                            v-for="(rateItem, index) in ratingSetDetailsList" 
                                                            :key="index" 
                                                            style="border: 1px solid #ccc; background-color: #f0f0f0; border-radius: 5px; font-size: 0.72rem; margin: 0; padding: 4px;"
                                                        >
                                                            <v-col cols="1" style="padding: 0;">
                                                                <v-radio :value="rateItem.rating"></v-radio>
                                                            </v-col>
                                                            <v-col cols="11" style="padding: 0;">
                                                                <div>
                                                                    <strong style="font-size:0.72rem;">{{ rateItem.rating }} - {{ rateItem.label }}</strong>
                                                                </div>
                                                                <div style="font-size:0.82rem;color:#555;font-weight:normal;letter-spacing:normal;">{{ rateItem.description }}</div>
                                                            </v-col>
                                                        </v-row>
                                                    </v-radio-group>
                                                </v-col>
                                            </v-row>
                                        </v-card>
                                    </v-col>


                                    <!-- Score Section (Right) -->
                                    <!-- <v-col cols="2" class="pb-0 pt-2 pl-0 ml-8">
                                        <v-text-field
                                        outlined
                                        label="Score"
                                        type="number"
                                        :rules="[rules.required]"
                                        :value="item.scorableScore === 0 ? '' : item.scorableScore"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col> -->
                                    <v-col cols="12">
                                        <div class="item-stat-bar">
                                                <!-- Normal reviewers -->
                                                <div class="item-stat" v-for="(childItem, cIndex) in normalChildren(item.id)" :key="'normal-' + cIndex">
                                                    <span class="item-stat-label">{{ reviewerLabels[cIndex] }}</span>
                                                    <span class="item-stat-value highlight">{{ childItem.rating }}</span>
                                                </div>
                                                <!-- HR reviewer -->
                                                <div class="item-stat" v-if="hrChild(item.id)">
                                                    <span class="item-stat-label">{{ finalReviewerLabel }}</span>
                                                    <span class="item-stat-value highlight">{{ hrChild(item.id).rating }}</span>
                                                </div>
                                                <!-- Item Rating -->
                                                <div class="item-stat">
                                                    <span class="item-stat-label">{{$t('pmselfservice.itemrating')}}</span>
                                                    <span class="item-stat-value highlight">{{ item.scorableRating }}</span>
                                                </div>
                                            </div>
                                    </v-col>
                                </v-row>
                                <v-row v-else class="ml-0 mt-3">
                                    <v-col cols="2" class="pb-0 pt-2 pl-0">
                                        <v-text-field
                                            outlined
                                            :label="$t('pmreviewexercisesectioncard.rating')"
                                            type="number"
                                            :rules="[rules.required, rules.minmaxrating]"
                                            v-model.number="item.scorableRating"
                                            dense
                                            @change="onRatingChange(item)"
                                            :disabled="isReadOnly"
                                            :background-color="formData.ratingset ? '#ffeab2' : 'transparent'"
                                            ></v-text-field>
                                    </v-col>
                                    <v-col cols="12">
                                        <div class="item-stat-bar">
                                            <!-- Normal reviewers -->
                                            <div class="item-stat" v-for="(childItem, cIndex) in normalChildren(item.id)" :key="'normal-' + cIndex">
                                                <span class="item-stat-label">{{ reviewerLabels[cIndex] }}</span>
                                                <span class="item-stat-value highlight">{{ childItem.rating }}</span>
                                            </div>
                                            <!-- HR reviewer -->
                                            <div class="item-stat" v-if="hrChild(item.id)">
                                                <span class="item-stat-label">{{ finalReviewerLabel }}</span>
                                                <span class="item-stat-value highlight">{{ hrChild(item.id).rating }}</span>
                                            </div>
                                            <!-- Item Rating -->
                                            <div class="item-stat">
                                                <span class="item-stat-label">{{$t('pmselfservice.itemrating')}}</span>
                                                <span class="item-stat-value highlight">{{ item.scorableRating }}</span>
                                            </div>
                                        </div>
                                    </v-col>
                                </v-row>
                                <v-row class="ml-0 mt-1 mb-2">
                                    <v-col cols="12" style="margin-top: 5px; margin-left:-10px;">
                                        <v-expansion-panels :value="expandAll ? 0 : undefined">
                                            <v-expansion-panel>
                                            <v-expansion-panel-header>
                                                <v-row class="ml-0" align="center">
                                                    <!-- Label on the left -->
                                                    <v-col cols="9" class="pl-0">
                                                        <h5 style="color:#4467C4;">{{ $t('performancemanagement.comments') }}</h5>
                                                    </v-col>
                                                    <!-- Plus button on the right -->
                                                    <v-col cols="3" class="text-right pr-0">
                                                        <v-btn 
                                                            icon 
                                                            small
                                                            color="primary" 
                                                            @click="addCommentsHandler(item)"
                                                            :disabled="isReadOnly"
                                                        >
                                                            <v-icon small>mdi-plus</v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                            </v-expansion-panel-header>
                                            <v-expansion-panel-content>
                                                <v-expansion-panels multiple :value="allPanelValues" style="margin-top:15px;">
                                                    <v-expansion-panel  v-for="(childItem, childIndex) in itemChildList.filter(child => child.pmreviewformsectiondid === item.id)" 
                                                        :key="childIndex">
                                                        <v-expansion-panel-header style="min-height:36px;">
                                                            <div style="display:flex;justify-content:space-between;align-items:center;width:100%;padding-right:8px;">
                                                                <h5 style="color:#1a3a5c;font-weight:600;margin:0;">{{ childItem.staffcode }} - {{ childItem.psnname }}</h5>
                                                            </div>
                                                        </v-expansion-panel-header>
                                                        <v-expansion-panel-content>
                                                            <v-row class="ml-0">
                                                                <v-col cols="11" class="pl-0 pb-0 mb-2">
                                                                    <div style="font-size:0.82rem;color:#555;letter-spacing:normal;">{{ childItem.comment }}</div>
                                                                </v-col>
                                                                <v-col cols="1" class="d-flex align-center justify-center pb-4">
                                                                    <v-btn icon small @click="modifyCommentsHandler(childItem)" :disabled="isReadOnly" style="color:#4F6BFF;">
                                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                                                        </svg>
                                                                    </v-btn>
                                                                </v-col>
                                                            </v-row>
                                                        </v-expansion-panel-content>
                                                    </v-expansion-panel>
                                                </v-expansion-panels>
                                            </v-expansion-panel-content>
                                            </v-expansion-panel>
                                        </v-expansion-panels>
                                    </v-col>
                                </v-row>
                                <!-- <v-row v-else class="ml-0 mt-3 mb-2">
                                    <v-col cols="2" class="pb-0 pt-2 pl-0">
                                        <v-text-field
                                        outlined
                                        :label="$t('Setupratingscaleset.score')"
                                        type="number"
                                        :rules="[rules.required]"
                                        :value="item.scorableScore === 0 ? '' : item.scorableScore"
                                        dense
                                        readonly
                                        background-color="#ffeab2"
                                        ></v-text-field>
                                    </v-col>
                                </v-row> -->
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-expansion-panel-content>

                <v-expansion-panel-content v-if="formData.sectionname == 'Comments'">
                    <!-- <div style="font-size: 0.9rem; margin-top: 15px; width: 100%; padding: 8px 16px;">
                        This is a small description that covers the full width of the panel and is a bit lower.
                    </div> -->
                    <!-- <h2 style="color:#1261a0; margin-bottom:5px; margin-top: 15px;" >Items</h2> -->
                    <span style="color:#4467C4; margin-top: 6px; margin-bottom: 2px; font-size: 0.88rem; font-weight: 600; letter-spacing: normal; display:block;">{{ formData.sectname }}</span>
                    <p style="margin-bottom:2px; margin-top:2px; font-size:0.82rem; color:#555; font-weight:normal; letter-spacing:normal;">{{ formData.description }}</p>
                    <v-expansion-panels multiple :value="allPanelValues" style="margin-top:15px;">
                        <v-expansion-panel v-for="(item, index) in itemsList" :key="index" class="mb-1">
                            <!-- Header Section -->
                            <v-expansion-panel-header>
                                <v-row class="ml-0" align="center">
                                    <!-- Label on the left -->
                                    <v-col cols="9" class="pl-0">
                                        <h5 style="color:#1a3a5c;font-weight:600;">{{ item.label }}</h5>
                                    </v-col>
                                    <!-- Plus button on the right -->
                                    <v-col cols="3" class="text-right pr-0">
                                        <v-btn 
                                            icon 
                                            small
                                            color="primary" 
                                            @click="addCommentsHandler(item)"
                                            :disabled="isReadOnly"
                                        >
                                            <v-icon small>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row class="ml-0">
                                    <v-col cols="12" class="pl-2 pb-0 pt-1">
                                        <div style="font-size:0.82rem;color:#555;font-weight:normal;letter-spacing:normal;">{{ item.description }}</div>
                                    </v-col>
                                </v-row>
                                <v-expansion-panels multiple :value="allPanelValues" class="mt-4">
                                    <v-expansion-panel  v-for="(childItem, childIndex) in itemChildList.filter(child => child.pmreviewformsectiondid === item.id)" 
                                        :key="childIndex">
                                        <v-expansion-panel-header style="min-height:36px;">
                                            <v-row class="ml-0 d-flex align-center justify-space-between">
                                                <v-col cols="11" class="pl-0 d-flex align-center">
                                                    <h5 style="color:#1a3a5c;font-weight:600;" >{{ childItem.staffcode }} - {{ childItem.psnname }}</h5>              
                                                </v-col>
                                                <v-col cols="1" sm="1" class="d-flex justify-end align-center">
                                                    <v-btn icon small @click="modifyCommentsHandler(childItem)" :disabled="isReadOnly" style="color:#4F6BFF;">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                                        </svg>
                                                    </v-btn>
                                                </v-col> 
                                            </v-row>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row class="ml-0">
                                                <v-col cols="12" class="pl-0 pb-0 mb-2">
                                                    <div style="font-size:0.82rem;color:#555;letter-spacing:normal;">{{ childItem.comment }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-expansion-panel-content>

                <v-expansion-panel-content v-if="formData.sectionname == 'Training Recommendations'">
                    <!-- <div style="font-size: 0.9rem; margin-top: 15px; width: 100%; padding: 8px 16px;">
                        This is a small description that covers the full width of the panel and is a bit lower.
                    </div> -->
                    <!-- <h2 style="color:#1261a0; margin-bottom:5px; margin-top: 15px;" >Items</h2> -->
                    <span style="color:#4467C4; margin-top: 6px; margin-bottom: 2px; font-size: 0.88rem; font-weight: 600; letter-spacing: normal; display:block;">{{ formData.sectname }}</span>
                    <p style="margin-bottom:2px; margin-top:2px; font-size:0.82rem; color:#555; font-weight:normal; letter-spacing:normal;">{{ formData.description }}</p>
                    <v-expansion-panels multiple :value="allPanelValues" style="margin-top:15px;">
                        <v-expansion-panel v-for="(item, index) in itemsList" :key="index" class="mb-1">
                            <!-- Header Section -->
                            <v-expansion-panel-header>
                                <v-row class="ml-0" align="center">
                                    <!-- Label on the left -->
                                    <v-col cols="9" class="pl-0">
                                        <h5 style="color:#1a3a5c;font-weight:600;">{{ item.label }}</h5>
                                    </v-col>
                                    <!-- Plus button on the right -->
                                    <v-col cols="3" class="text-right pr-0">
                                        <v-btn 
                                            icon 
                                            small
                                            color="primary" 
                                            @click="addCommentsHandler(item)"
                                            :disabled="isReadOnly"
                                        >
                                            <v-icon small>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row class="ml-0">
                                    <v-col cols="12" class="pl-2 pb-0 pt-1">
                                        <div style="font-size:0.82rem;color:#555;font-weight:normal;letter-spacing:normal;">{{ item.description }}</div>
                                    </v-col>
                                </v-row>
                                <v-expansion-panels multiple :value="allPanelValues" class="mt-4">
                                    <v-expansion-panel  v-for="(childItem, childIndex) in itemChildList.filter(child => child.pmreviewformsectiondid === item.id)" 
                                        :key="childIndex">
                                        <v-expansion-panel-header style="min-height:36px;">
                                            <v-row class="ml-0 d-flex align-center justify-space-between">
                                                <v-col cols="11" class="pl-0 d-flex align-center">
                                                    <h5 style="color:#1261a0;" >{{ childItem.coursename }}</h5>              
                                                </v-col>
                                                <v-col cols="1" sm="1" class="d-flex justify-end align-center">
                                                    <v-btn icon small @click="modifyTrainHandler(childItem)" :disabled="isReadOnly" style="color:#4F6BFF;">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                                        </svg>
                                                    </v-btn>
                                                </v-col> 
                                            </v-row>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row class="ml-0">
                                                <v-col cols="1" class="pl-0 pb-0 mb-4 ml-4">
                                                    <div>{{$t('payeeinputprocess.justification')}}</div>
                                                </v-col>
                                                <v-col cols="9" class="pl-0 pb-0 mb-4">
                                                    <div style="font-weight: bold;">{{ childItem.justification }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row class="ml-0">s
                                                <v-col cols="1" class="pl-0 pb-0 mb-4 ml-4">
                                                    <div>{{$t('columns.priority')}}</div>
                                                </v-col>
                                                <v-col cols="9" class="pl-0 pb-0 mb-4">
                                                    <div style="font-weight: bold;">{{ childItem.priority }}</div>
                                                </v-col>
                                            </v-row>
                                            <v-row class="ml-0 align-center">
                                                <v-col cols="1" class="pl-0 pb-0 mb-4 ml-4">
                                                    <div>{{$t('columns.reference')}}</div>
                                                </v-col>
                                                <v-col cols="9" class="pl-0 pb-0 mb-4">
                                                    <p style="margin: 0;">
                                                        <a 
                                                            v-bind:href="childItem.attach" 
                                                            v-bind:download="childItem.attachname" 
                                                            style="font-size: 0.75rem;"
                                                        >
                                                            {{childItem.attachname}}
                                                        </a>
                                                    </p>
                                                </v-col>
                                            </v-row>
                                            <v-row class="ml-0">
                                                <v-col cols="1" class="pl-0 pb-0 mb-4 ml-4">
                                                    <div>{{$t('columns.remark')}}</div>
                                                </v-col>
                                                <v-col cols="9" class="pl-0 pb-0 mb-4">
                                                    <div style="font-weight: bold;">{{ childItem.remark }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-expansion-panel-content>

                <v-expansion-panel-content v-if="formData.sectionname == 'Movement Recommendations'">
                    <!-- <div style="font-size: 0.9rem; margin-top: 15px; width: 100%; padding: 8px 16px;">
                        This is a small description that covers the full width of the panel and is a bit lower.
                    </div> -->
                    <!-- <h2 style="color:#1261a0; margin-bottom:5px; margin-top: 15px;" >Items</h2> -->
                    <span style="color:#4467C4; margin-top: 6px; margin-bottom: 2px; font-size: 0.88rem; font-weight: 600; letter-spacing: normal; display:block;">{{ formData.sectname }}</span>
                    <p style="margin-bottom:2px; margin-top:2px; font-size:0.82rem; color:#555; font-weight:normal; letter-spacing:normal;">{{ formData.description }}</p>
                    <v-expansion-panels multiple :value="allPanelValues" style="margin-top:15px;">
                        <v-expansion-panel v-for="(item, index) in itemsList" :key="index" class="mb-1">
                            <!-- Header Section -->
                            <v-expansion-panel-header>
                                <v-row class="ml-0" align="center">
                                    <!-- Label on the left -->
                                    <v-col cols="9" class="pl-0">
                                        <h5 style="color:#1a3a5c;font-weight:600;">{{ item.label }}</h5>
                                    </v-col>
                                    <!-- Plus button on the right -->
                                    <v-col cols="3" class="text-right pr-0">
                                        <v-btn 
                                            icon 
                                            small
                                            color="primary" 
                                            @click="addCommentsHandler(item)"
                                            :disabled="isReadOnly"
                                        >
                                            <v-icon small>mdi-plus</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-row class="ml-0">
                                    <v-col cols="12" class="pl-2 pb-0 pt-1">
                                        <div style="font-size:0.82rem;color:#555;font-weight:normal;letter-spacing:normal;">{{ item.description }}</div>
                                    </v-col>
                                </v-row>
                                <v-expansion-panels multiple :value="allPanelValues" class="mt-4">
                                    <v-expansion-panel  v-for="(childItem, childIndex) in itemChildList.filter(child => child.pmreviewformsectiondid === item.id)" 
                                        :key="childIndex">
                                        <v-expansion-panel-header style="min-height:36px;">
                                            <v-row class="ml-0 d-flex align-center justify-space-between">
                                                <v-col cols="11" class="pl-0 d-flex align-center">
                                                    <h5 style="color:#1261a0;" >{{$t('pmreviewexercisesectioncard.proposal')}} - {{ childItem.proposal }}</h5>              
                                                </v-col>
                                                <v-col cols="1" sm="1" class="d-flex justify-end align-center">
                                                    <v-btn icon small @click="modifyMovHandler(childItem)" :disabled="isReadOnly" style="color:#4F6BFF;">
                                                        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                                            <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                                            <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                                        </svg>
                                                    </v-btn>
                                                </v-col> 
                                            </v-row>
                                        </v-expansion-panel-header>
                                        <v-expansion-panel-content>
                                            <v-row class="ml-0">
                                                <v-col cols="1" class="pl-0 pb-0 mb-4 ml-4">
                                                    <div>{{$t('payeeinputprocess.justification')}}</div>
                                                </v-col>
                                                <v-col cols="9" class="pl-0 pb-0 mb-4">
                                                    <div style="font-weight: bold;">{{ childItem.justification }}</div>
                                                </v-col>
                                            </v-row>
                                        </v-expansion-panel-content>
                                    </v-expansion-panel>
                                </v-expansion-panels>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-expansion-panel-content>

                </v-expansion-panel>
            </v-expansion-panels>
        </div>
        <div v-if="isErr">  
            <app-error
                v-bind:parentError="{
                data: this.errMsg,
                isErr: this.isErr,
                }"
                v-on:closeError="isErr = $event"
            />
        </div>
    </div>
</template>

<script>
import ErrorDialog from "../../components/common/ErrorDialog";
import moment from "moment";
import Vue from 'vue';


export default {
    props: {
        parentObject: Object,
        expandAll: {
            type: Boolean,
            default: false,
        },
    },

    components: {
        "app-error": ErrorDialog,
    },

    data() {
        return {
            rules: {
                required: value => !!value || this.$t('reportsparam.required'),
                minmaxrating: value => {
                    if (!this.formData.ratingset) {
                    const min = this.formData.minrating;
                    const max = this.formData.maxrating;

                    // Ensure value is within the range
                    if (value >= min && value <= max) {
                        return true; // Passes validation
                    }

                    // Fails validation: Provide a static error message
                    return this.$t('reportsparam.range', { min, max });
                    // return `The value must be between ${min} and ${max}.`;
                    }

                    // If ratingset is not null, validation is not applicable
                    return true;
                },
            },

            //Read-only
            formData: {
                ...this.parentObject.formData,
                scorableRating: null,
                scorableScore: null,
            },

            commentsData: {
                id: null,
                pmreviewformsectiondid: null,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                staffid: this.$store.getters.staffId,
                staffcode: null,
                staffcompany: null,
                comment: null,
                secttype: "Comments",
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            scorableCommentsData: {
                id: null,
                pmreviewformsectiondid: null,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                staffid: this.$store.getters.staffId,
                staffcode: null,
                staffcompany: null,
                comment: null,
                attach: null,
                attachname: null,
                secttype: "Scorable Section",
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            movData: {
                id: null,
                pmreviewformsectiondid: null,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                proposal: null,
                justification: null,
                secttype: "Movement Recommendations",
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            trainData: {
                id: null,
                pmreviewformsectiondid: null,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                coursename: null,
                priority: null,
                justification: null,
                remark: null,
                attach: null,
                attachname: null,
                secttype: "Training Recommendations",
                stamp: 0,
                userid: this.$store.getters.userId,
            },

            indKPIData: {
                ...this.parentObject.indKPIData,
            },

            indKPIList: [],
            cmmKPIList: [],
            itemsList: [],
            itemChildList: [],
            itemChildListScorable: [],
            staffList: [],
            progressReviewList: [],
            progressReviewCommentList: [],
            ratingSetDetailsList: [],

            priorityDialog: false,
            priorityies: [],
            priorityList: [],
            priorityItems: [],

            DelegatedWFTranDetails: this.parentObject.DelegatedWFTranDetails,
            fileHolder: null,
            panelOpen: undefined,

            // sectionTypeList: [],
            // loadingSection: true,

            commentsDialog: false,
            totalObjectiveItemWeightage: 0,
            totalScorableItemWeightage: 0,
            shouldWatchIndKPIList: false, // control when the watcher should activate
            reviewerLabels: [this.$t('pmselfservice.firstreviewerrating'), this.$t('pmselfservice.secondreviewerrating'), this.$t('pmselfservice.thirdreviewerrating'), this.$t('pmselfservice.fourthreviewerrating'), this.$t('pmselfservice.fifthreviewerrating')],
            finalReviewerLabel: this.$t('pmselfservice.finalreviewerrating'),
            indKPIFinalRatings: [],
            //error msg and dialog, check for duplicates vars
            isExisting: false,
            isErr: false,
            isEditComments: false,
            errMsg: '',
        }
    },

    watch: {
        expandAll(val) {
            this.panelOpen = val ? 0 : undefined;
        },

        indKPIList: {
            immediate: true,
            async handler(newList) {
                if (!this.shouldWatchIndKPIList) return;

                const vm = this;
                vm.progressReviewCommentList = []; // Clear the previous comments

                if (newList && newList.length > 0) {
                    // Use Promise.all to wait for all async operations
                    await Promise.all(
                        newList.map(async (item) => {
                            // Load progress reviews for the item
                            item.progressReviewList = await this.loadProgressReview(item.id, item);
                            item.rating = item.progressReviewList[0]?.indkpirate || 0;
                            item.score = item.progressReviewList[0]?.itemscore || 0;

                            if (item.progressReviewList && item.progressReviewList.length > 0) {
                                for (let review of item.progressReviewList) {
                                    // Load comments for each review
                                    const comments = await this.loadAllProgressReviewComments(review.id);
                                    review.progressReviewCommentList = comments;

                                    // Push all comments to vm.progressReviewCommentList
                                    vm.progressReviewCommentList.push(...comments);
                                }
                            }
                        })
                    );
                }
            },
        },
        'commentsData.staffid': {
            handler(newStaffId) {
                const selectedStaff = this.staffList.find(staff => staff.value === newStaffId);
                if (selectedStaff) {
                    this.commentsData.staffcode = selectedStaff.staffcode;
                    this.commentsData.staffcompany = selectedStaff.staffcompany;
                } else {
                    this.commentsData.staffcode = '';
                    this.commentsData.staffcompany = '';
                }
            },
            immediate: true // Updates the fields when the component loads if `staffid` is already set
        },
        'scorableCommentsData.staffid': {
            handler(newStaffId) {
                const selectedStaff = this.staffList.find(staff => staff.value === newStaffId);
                if (selectedStaff) {
                    this.scorableCommentsData.staffcode = selectedStaff.staffcode;
                    this.scorableCommentsData.staffcompany = selectedStaff.staffcompany;
                } else {
                    this.scorableCommentsData.staffcode = '';
                    this.scorableCommentsData.staffcompany = '';
                }
            },
            immediate: true // Updates the fields when the component loads if `staffid` is already set
        },
    },

    computed: {
        normalChildren() {
            return (sectionId) =>
                this.itemChildListScorable.filter(
                    child => child.pmreviewformsectiondid === sectionId && !child.isHR && !child.isDraft
                );
        },

        hrChild() {
            return (sectionId) =>
                this.itemChildListScorable.find(
                    child => child.pmreviewformsectiondid === sectionId && child.isHR
                );
        },
        isReadOnly() {
            return this.parentObject.DelegatedWFTranDetails.length < 1;
        },
        allPanelValues() {
            return this.expandAll ? [...Array(100).keys()] : [];
        },
    },

    methods: {
    //     expandPanels() {
    //         const expandAllPanels = (element) => {
    //             const panels = element.querySelectorAll('.v-expansion-panel');
    //             let expandedAny = false;

    //             panels.forEach(panel => {
    //             const header = panel.querySelector('.v-expansion-panel-header');
    //             if (header && !header.classList.contains('v-expansion-panel-header--active')) {
    //                 header.click(); // Expand the panel
    //                 expandedAny = true;
    //             }
    //             });

    //             return expandedAny; // Returns true if any panel was expanded
    //         };

    //         // Keep expanding until no more panels can be expanded
    //         const expandRecursively = (element) => {
    //             if (expandAllPanels(element)) {
    //             setTimeout(() => expandRecursively(element), 50); // Wait and expand again
    //             }
    //         };

    //         expandRecursively(this.$el);
    //     },

    //     saveAsPDF() {
    //         const element = this.$refs.printableDiv; // Reference to your <div>

    //         if (!html2canvas) {
    //             console.error("html2canvas not loaded");
    //             return;
    //         }

    //         html2canvas(element, { scale: 2 }) // Generate a canvas from HTML
    //             .then(canvas => {
    //             const imgData = canvas.toDataURL('image/png');
    //             const pdf = new jsPDF({
    //                 orientation: 'portrait',
    //                 unit: 'mm',
    //                 format: 'a4',
    //             });

    //             const pdfWidth = pdf.internal.pageSize.getWidth();
    //             const pdfHeight = (canvas.height * pdfWidth) / canvas.width;

    //             pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
    //             pdf.save('section-details.pdf');
    //             })
    //             .catch(error => {
    //             console.error('Error generating PDF:', error);
    //             });
    //     },

        async loadIndKPI() {
            const vm = this;
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewexercise/items/indkpi/${vm.indKPIData.pmreviewexerciseid}/${vm.indKPIData.staffid}`,
                });
                vm.indKPIList = res.data.rec || [];
                console.log("INDKPILIST", vm.indKPIList);
            } catch (err) {
                console.error("Error in loadIndKPI:", err);
            }
        },

        async loadCommonKPI() {
            const vm = this;

            // Check if indKPIList is populated before proceeding
            if (!vm.indKPIList || vm.indKPIList.length === 0) {
                console.warn("indKPIList is empty. Cannot load common KPI.");
                return;
            }

            // Add weightage from indKPIList now
            vm.totalObjectiveItemWeightage = vm.indKPIList.reduce(
                (sum, item) => sum + Number(item.weightage),
                0
            );

            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewexercise/items/cmmkpi/${vm.indKPIList[0].kpiexerdid}`,
                });
                vm.cmmKPIList = res.data.rec || [];
                const ratingSetDetails = this.ratingSetDetailsList || [];

                //we have to get total Item Weightage for all items in CMMKPIList and Individual 
                vm.totalObjectiveItemWeightage += vm.cmmKPIList.reduce(
                    (sum, item) => sum + Number(item.weightage),
                    0
                );

                vm.cmmKPIList.forEach((item) => {
                    const progress = item.progress || 0;
                    item.rating = this.determineRate(progress, ratingSetDetails);
                    console.log(`cmmkpi for progress ${progress}:`, item.rating);
                    item.score = this.calculateItemScore(item.rating, this.formData.sectdivider, item.weightage, 1);
                });

                console.log("cmmKPILIST", vm.cmmKPIList);
            } catch (err) {
                console.error("Error in loadCommonKPI:", err);
            }
        },

        async processIndKPIList() {
            const vm = this;
            vm.progressReviewCommentList = [];

            const list = vm.indKPIList;

            await Promise.all(
                list.map(async (item) => {
                const reviewList = await this.loadProgressReview(item.id, item);
                this.$set(item, 'progressReviewList', reviewList); 

                item.rating = item.progressReviewList[0]?.indkpirate || 0;
                item.score = item.progressReviewList[0]?.itemscore || 0;

                if (item.progressReviewList?.length > 0) {
                    for (let review of item.progressReviewList) {
                    const comments = await this.loadAllProgressReviewComments(review.id);
                    this.$set(review, 'progressReviewCommentList', comments); 
                    vm.progressReviewCommentList.push(...comments);
                    }
                }
                })
            );
        },

        async loadProgressReview(indKPIId, indKPIData) {
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewexercise/items/progressreview/${indKPIId}`,
                });
                const progressReviewList = (res.data.rec || []).map((item) => {
                    // Format reviewdate using moment
                    if (item.reviewdate) {
                        item.reviewdate = moment(item.reviewdate).format("DD/MM/YYYY");
                    }
                    return item;
                });

                const progress = progressReviewList[0]?.realprogress || 0;
                let ratingSetDetails = this.ratingSetDetailsList || []; 
                if (indKPIData.pmratesetid){ //if KPI has rating set in KPI Item, use it, else just use normal rating set
                    ratingSetDetails = await this.loadRatingSetDetailsIndKPI(indKPIData.pmratesetid);
                }
                const indkpirate = this.determineRate(progress, ratingSetDetails);
                const itemscore = this.calculateItemScore(indkpirate, this.formData.sectdivider, indKPIData.weightage, 1);

                progressReviewList[0] = {
                    ...progressReviewList[0], 
                    indkpirate: indkpirate, 
                    itemscore: itemscore
                };


                console.log(`indkpirate for progress ${progress}:`, progressReviewList[0].indkpirate);

                console.log(`Progress reviews for indKPIId ${indKPIId}:`, progressReviewList);
                return progressReviewList;
            } catch (err) {
                console.error(`Error in loadProgressReview for indKPIId ${indKPIId}:`, err);
                return [];
            }
        },

        async loadINDKPIFinalRatings() {
            const vm = this;

            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewexercise/indkpi/finalrating/${vm.indKPIList[0].kpiexerdid}`,
                });
                vm.indKPIFinalRatings = res.data.rec || [];
                console.log("indKPIFinalRatings", vm.indKPIFinalRatings);

                // Loop through each final rating and update the matching item in indKPIList
                vm.indKPIFinalRatings.forEach(finalRating => {
                    const index = vm.indKPIList.findIndex(item => item.id === finalRating.pmkpiexercisedindkpiid);

                    if (index !== -1) {
                        const item = vm.indKPIList[index];

                        // Update the rating and recalculate score
                        const newScore = vm.calculateItemScore(finalRating.rating, vm.formData.sectdivider, item.weightage, 1);

                        // Vue reactivity: replace the object
                        vm.$set(vm.indKPIList, index, { 
                            ...item, 
                            rating: finalRating.rating, 
                            score: newScore 
                        });
                    }
                });
            } catch (err) {
                console.error("Error in loadINDKPIFinalRatings:", err);
            }
        },

        determineRate(progress, ratingSetDetails) {
            // Sort ratingSetDetails by score in ascending order to simplify comparisons
            const sortedDetails = [...ratingSetDetails].sort((a, b) => a.score - b.score);

            for (let i = 0; i < sortedDetails.length; i++) {
                const current = sortedDetails[i];
                const previous = sortedDetails[i - 1] || { score: -Infinity };

                // Check if the progress falls within the current range
                if (progress > previous.score && progress <= current.score) {
                    return current.rating;
                }
            }

            return 0; // Return 0 if no range matches
        },

        calculateItemScore(rating, divider, itemweightage, method) {
            const vm = this;
            var itemscore = 0;
            var totalItemWeightage = 0;

            if (this.formData.sectionname == 'Objective') {
                totalItemWeightage = vm.totalObjectiveItemWeightage; 
            } else if (this.formData.sectionname == 'Scorable Section') {
                totalItemWeightage = vm.totalScorableItemWeightage; 
                //Only get the items being reviewed
                if (method == 2) { 
                totalItemWeightage = vm.itemsList
                    .filter(item => item.scorableRating !== null)
                    .reduce((sum, item) => sum + Number(item.weightage), 0);
                }
            } else {
                totalItemWeightage = 0;
            }

            itemscore = ((rating / divider) * (itemweightage / totalItemWeightage) * 100).toFixed(2);

            return itemscore; 
        },


        async loadAllProgressReviewComments(reviewID) {
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewexercise/items/progressreviewcomment/${reviewID}`,
                });
                const progressReviewCommentList = (res.data.rec || []).map((item) => {
                    return item;
                });
                console.log(`Progress review comment for reviewID ${reviewID}:`, progressReviewCommentList);
                return progressReviewCommentList;
            } catch (err) {
                console.error(`Error in loadProgressReviewComments for reviewID ${reviewID}:`, err);
                return [];
            }
        },

        async loadRatingSetDetails() {
            const vm = this;
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/ratingsetdetails/${vm.parentObject.formData.ratingset}`,
                });
                vm.ratingSetDetailsList = res.data.rec || [];
                console.log("ratingSetDetailsList", vm.ratingSetDetailsList);
            } catch (err) {
                console.error("Error in loadRatingSetDetails:", err);
            }
        },

        async loadRatingSetDetailsIndKPI(pmratesetid) {
            try {
                const res = await this.$store.dispatch("get", {
                    url: `/ratingsetdetails/${pmratesetid}`,
                });
                return res.data.rec || [];
            } catch (err) {
                console.error("Error in loadRatingSetDetails:", err);
            }
        },

        async calculateObjectiveSectionScore() {
            try {
                console.log("Calculating objective section score...");
                console.log("CMMKPI",this.cmmKPIList);
                console.log("INDKPI", this.indKPIList);
                console.log("SECTDATA", this.formData);

                let totalCMMWeightage = 0;
                let totalINDWeightage = 0;
                let totalCMMScore = 0;
                let totalINDScore = 0;

                this.cmmKPIList.forEach(item => {
                    totalCMMWeightage += parseFloat(item.weightage) || 0;
                    totalCMMScore += parseFloat(item.score) || 0;
                });
                this.indKPIList.forEach(item => {
                    totalINDWeightage += parseFloat(item.weightage) || 0;
                    totalINDScore += parseFloat(item.score) || 0;
                });

                // let totalWeightage = this.totalObjectiveItemWeightage;
                let totalScore = totalCMMScore + totalINDScore;
                //old one
                // let sectionScore = (totalScore / totalWeightage) * this.formData.sectweightage;

                let sectionScore = (totalScore / 100) * this.formData.maxscore * (this.formData.sectweightage / this.parentObject.totalSectWeightage); 
                this.formData.sectionScore = sectionScore.toFixed(2);
                this.$emit('update-objectivesection-score', this.formData.sectionScore); 

                console.log("Total CMMWeightage:", totalCMMWeightage);
                console.log("Total INDWeightage:", totalINDWeightage);
                console.log("Total CMMScore:", totalCMMScore);
                console.log("Total INDScore:", totalINDScore);
                // console.log("Total Weightage:", totalWeightage);
                console.log("Total Score:", totalScore);
                console.log("Section Score:", sectionScore);


            } catch (err) {
                console.error(`Error in calculateObjectiveSectionScore`, err);
                return [];
            }
        },

        async loadSectionItems() {
            const vm = this;

            try {
                const res = await this.$store.dispatch("get", {
                    url: `/reviewformsection/item/${vm.formData.id}`,
                });
                vm.itemsList = res.data.rec || [];
                vm.itemsList.forEach(item => {
                    if (!item.hasOwnProperty('scorableRating')) {
                        Vue.set(item, 'scorableRating', null);  // null = not yet rated; 0 is a valid explicit rating
                    }
                    if (!item.hasOwnProperty('scorableScore')) {
                        Vue.set(item, 'scorableScore', 0);  // Use Vue.set to make it reactive
                    }
                });
                console.log(vm.formData.sectionname);
                console.log("ITEMSLIST", vm.itemsList);

                vm.totalScorableItemWeightage = vm.itemsList.reduce(
                    (sum, item) => sum + Number(item.weightage),
                    0
                );

            } catch (err) {
                console.error("Error in loadSectionItems:", err);
            }
        },

        onRatingChange(item) {
            if (this.formData.calcmethod == 2) {
                this.itemsList.forEach(it => {
                    if (it.scorableRating !== null) {
                        it.scorableScore = this.calculateItemScore(it.scorableRating, this.formData.itemdivider, it.weightage, this.formData.calcmethod);
                    }
                });
            } else{//else just calculate own score
                item.scorableScore = this.calculateItemScore(item.scorableRating, this.formData.itemdivider, item.weightage, this.formData.calcmethod);
            }
            this.calculateScorableSectionScore();

            //send itemslist
            this.$emit('update-scorablesection-rating', this.itemsList); 
        },

        calculateScorableSectionScore(){
            let totalWeightage = 0;
            let totalScore = 0;
            this.itemsList.forEach(item => {
                totalWeightage += parseFloat(item.weightage) || 0;
                totalScore += parseFloat(item.scorableScore) || 0;
            });

            console.log("Total Weightage:", totalWeightage);
            console.log("Total Score:", totalScore);
            console.log("Section Weightage:", this.formData.sectweightage);

            // old one
            // let sectionScore = (totalScore / totalWeightage) * this.formData.sectweightage;

            let sectionScore = (totalScore / 100) * this.formData.maxscore * (this.formData.sectweightage / this.parentObject.totalSectWeightage); 
            this.formData.sectionScore = sectionScore.toFixed(2);
            this.$emit('update-scorablesection-score', {id: this.formData.id, score: this.formData.sectionScore}); 
        },

        async loadItemChild() {
            console.log("LOAD ITEM CHILD");
            const vm = this;

            try {
                console.log("TRY");
                for (const item of vm.itemsList) {
                    console.log("ITEM", item.id);
                    const res = await vm.$store.dispatch("get", {
                        url: `/reviewformsectiond/item/${item.id}/${this.parentObject.review.reviewstaffreviewerid}`,
                    });

                    vm.itemChildList.push(...(res.data.rec || []));
                    console.log("ITEMCHILD", vm.itemChildList);
                }
                console.log("itemChildList", vm.itemChildList);
                vm.assignStaffDetailsToItems(); // Assign staff details after loading itemChildList

            } catch (err) {
                console.error("Error in loadItemChild:", err);
            }
        },

        async loadItemChildScorable() {
            console.log("LOAD ITEM CHILD SCORABLE");
            console.log("REVIEW", this.parentObject.review);
            const vm = this;

            try {
                console.log("TRY");
                for (const item of vm.itemsList) {
                    console.log("ITEM", item.id);
                    const res = await vm.$store.dispatch("get", {
                        url: `/reviewformsectiond/item/scorable/${item.id}/${this.parentObject.review.reviewstaffreviewerid}`,
                    });

                    vm.itemChildListScorable.push(...(res.data.rec || []));
                    console.log("ITEMCHILDSCORABLE", vm.itemChildListScorable);
                }

                console.log("ITEMSLISTCHILDSCORABLE", vm.itemsList);

                // After sorting itemChildListScorable
                for (const item of vm.itemsList) {
                    // Find all scorable children for this item
                    const related = vm.itemChildListScorable.filter(
                        child => child.pmreviewformsectiondid === item.id
                    );

                    if (related.length > 0) {
                        // Pick the latest by rectimestamp
                        const latest = related.reduce((a, b) => {
                            return new Date(a.rectimestamp) > new Date(b.rectimestamp) ? a : b;
                        });

                        // Update scorableRating in itemsList
                        item.scorableRating = latest.rating;
                        this.onRatingChange(item);
                    } 
                }

                console.log("ITEMSLISTCHILDSCORABLEAFTER", vm.itemsList);


                console.log("itemChildListScorable", vm.itemChildListScorable);
                vm.itemChildListScorable.sort((a, b) => {
                    // If rectimestamp is a string, convert to Date for comparison
                    const aTime = new Date(a.rectimestamp).getTime();
                    const bTime = new Date(b.rectimestamp).getTime();
                    return aTime - bTime;
                });

            } catch (err) {
                console.error("Error in loadItemChildScorable:", err);
            }
        },

        assignStaffDetailsToItems() {
            const vm = this;

            // Map staff details into itemChildList
            vm.itemChildList.forEach(childItem => {
                const staff = vm.staffList.find(staff => staff.value === childItem.staffid);
                if (staff) {
                    // Assign new properties to the child item
                    childItem.staffcode = staff.staffcode || null;
                    childItem.psnname = staff.psnname || null;
                    childItem.staffcompany = staff.staffcompany || null;
                }
            });

            console.log("UPDATEDCHILDLIST", vm.itemChildList);
        },

        async loadStaff(){
            const vm = this;

            try {
                const res = await vm.$store.dispatch("get", {
                    url: `/staff/alls`
                });

                const staffFull = res.data.rec || [];

                vm.staffList = staffFull.map(staff => ({
                        text: staff.psndetails,
                        psnname: staff.psnname,
                        staffcode: staff.staffcode,
                        staffcompany: staff.compnyname,
                        value: staff.id,
                    }));
                console.log("STAFFLIST", vm.staffList);

            } catch (err) {
                console.error("Error in loadStaff:", err);
            }
        },

        addCommentsHandler(item){
            console.log("ADD COMMENTS", item);
            this.commentsData.pmreviewformsectiondid = item.id;
            this.movData.pmreviewformsectiondid = item.id;
            this.trainData.pmreviewformsectiondid = item.id;
            this.scorableCommentsData.pmreviewformsectiondid = item.id;
            console.log("ADD COMMENTS", this.commentsData);
            console.log("ADD MOV", this.movData);
            console.log("ADD TRAIN", this.trainData);
            console.log("ADD SCORABLE", this.scorableCommentsData);
            this.commentsDialog = true;
        },

        modifyCommentsHandler(childItem) {
            console.log("CHILDITEM", childItem);
            if (this.formData.sectionname == 'Scorable Section') {
                this.scorableCommentsData = { ...this.scorableCommentsData, ...childItem };
                console.log("EDITSCORABLECOMMENTSDATA", this.scorableCommentsData);
            } else if (this.formData.sectionname == 'Comments') {
                this.commentsData = { ...this.commentsData, ...childItem };
                console.log("EDITCOMMENTSDATA", this.commentsData);
            }
            this.isEditComments = true;
            this.commentsDialog = true;
            //assign childItem to commentsData
        },

        modifyMovHandler(childItem) {
            console.log("CHILDITEM", childItem);
            this.movData = { ...this.movData, ...childItem };
            console.log("EDITMOV", this.movData);
            this.isEditComments = true;
            this.commentsDialog = true;
            //assign childItem to commentsData
        },

        modifyTrainHandler(childItem) {
            console.log("CHILDITEM", childItem);
            this.trainData = { ...this.trainData, ...childItem };
            console.log("EDITTRAIN", this.trainData);
            this.isEditComments = true;
            this.commentsDialog = true;
            //assign childItem to commentsData
        },

        deleteHandler() {
            const vm = this;

            if(vm.formData.sectionname === 'Comments'){
                if (confirm("Are you sure you want to delete this comment?")) {
                    this.$store
                        .dispatch('delete', { url: "/reviewformsectiond/item/" + this.commentsData.id })
                        .then(() => {
                            const index = vm.itemChildList.findIndex(child => child.id === vm.commentsData.id);
                            if (index !== -1) {
                                vm.itemChildList.splice(index, 1); // Remove the item from the array
                            }
                            vm.commentsDialog = false;
                            vm.resetSelections();
                        })
                        .catch((err) => {
                            vm.errMsg = err.message || err;
                        });
                }
            }else if(vm.formData.sectionname === 'Movement Recommendations'){
                if (confirm("Are you sure you want to delete this proposal?")) {
                    this.$store
                        .dispatch('delete', { url: "/reviewformsectiond/item/" + this.movData.id })
                        .then(() => {
                            const index = vm.itemChildList.findIndex(child => child.id === vm.movData.id);
                            if (index !== -1) {
                                vm.itemChildList.splice(index, 1); // Remove the item from the array
                            }
                            vm.commentsDialog = false;
                            vm.resetSelections();
                        })
                        .catch((err) => {
                            vm.errMsg = err.message || err;
                        });
                }
            }else if(vm.formData.sectionname === 'Training Recommendations'){
                if (confirm("Are you sure you want to delete this training recommendation?")) {
                    this.$store
                        .dispatch('delete', { url: "/reviewformsectiond/item/" + this.trainData.id })
                        .then(() => {
                            const index = vm.itemChildList.findIndex(child => child.id === vm.trainData.id);
                            if (index !== -1) {
                                vm.itemChildList.splice(index, 1); // Remove the item from the array
                            }
                            vm.commentsDialog = false;
                            vm.resetSelections();
                        })
                        .catch((err) => {
                            vm.errMsg = err.message || err;
                        });
                }
            }else if(vm.formData.sectionname === 'Scorable Section'){
                if (confirm(this.$t('pmreviewexercisesectioncard.deletecomment'))) {
                    this.$store
                        .dispatch('delete', { url: "/reviewformsectiond/item/" + this.scorableCommentsData.id })
                        .then(() => {
                            const index = vm.itemChildList.findIndex(child => child.id === vm.scorableCommentsData.id);
                            if (index !== -1) {
                                vm.itemChildList.splice(index, 1); // Remove the item from the array
                            }
                            vm.commentsDialog = false;
                            vm.resetSelections();
                        })
                        .catch((err) => {
                            vm.errMsg = err.message || err;
                        });
                }
            }
        },

        async getPriorityListHandler() {
            try {
                const res = await this.$store.dispatch('get', { url: '/priority/all' });

                this.priorities = res.data.rec;

                // Clear the arrays before populating them to avoid duplication
                this.priorityList = [];
                this.priorityItems = [];

                for (let i = 0; i < res.data.rec.length; i++) {
                    this.priorityList.push({
                        text: res.data.rec[i].priorityname,
                        value: res.data.rec[i].id
                    });

                    this.priorityItems.push({
                        id: res.data.rec[i].id,
                        code: res.data.rec[i].prioritycode,
                        desc: res.data.rec[i].priorityname,
                        stamp: res.data.rec[i].stamp
                    });
                }
            } catch (err) {
                this.isErr = true;
                this.errMsg = err.message || err;
                this.$emit('error', { isErr: this.isErr, errMsg: this.errMsg });
            }
        },


        savePriorityHandler() {
            let vm = this;
            if (this.itemData.itemid) {
                this.$store.dispatch('put', {url: '/priority/' + this.itemData.itemid, payload: {
                    prioritycode: vm.itemData.itemcode,
                    priorityname: vm.itemData.itemdesc,
                    stamp: vm.itemData.itemstamp
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // reset all arrays
                        vm.priorities = [];
                        vm.priorityList = [],
                        vm.priorityItems = [],

                        this.getPriorityListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            } else {
                this.$store.dispatch('post', {url: '/priority/create', payload: {
                    prioritycode: vm.itemData.itemcode,
                    priorityname: vm.itemData.itemdesc,
                    userid: this.$store.getters.userId,
                }})
                .then(res => {
                    if (res.data.status == 201) {
                        // reset all arrays
                        vm.priorities = [];
                        vm.priorityList = [],
                        vm.priorityItems = [];

                        this.getPriorityListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deletePriorityHandler($event) {
            let vm = this;

            if (confirm('Remove ' + $event.desc + '?')) {
                this.$store.dispatch('delete', {url: '/priority/' + $event.id + '/' + this.$store.getters.userId})
                .then(res => {
                    if (res.data.status == 200) {
                        // reset all arrays
                        vm.priorities = [];
                        vm.priorityList = [],
                        vm.priorityItems = [],

                        this.getPriorityListHandler();
                    } else {
                        vm.isErr = true;
                        vm.errMsg = res.data.error;
                        vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                    }
                })
                .catch(err => {
                    vm.isErr = true;
                    vm.errMsg = err;
                    vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
                });
            }
        },

        deleteItemHandler(sectionType) {
          if(sectionType == 'trainData'){
            this.trainData.attach = null
            this.trainData.attachname = null
          } else if (sectionType == 'scorableCommentsData'){
            this.scorableCommentsData.attach = null
            this.scorableCommentsData.attachname = null
          }
          this.fileHolder = null;
          if (this.$refs.attach) this.$refs.attach.reset();
        },

        fileToBase64(sectionType) {
          if (this.fileHolder) {
            var file = this.$refs.attach.internalValue;
            if(sectionType == 'trainData'){
                this.trainData.attachname = this.fileHolder.name
            }else if (sectionType == 'scorableCommentsData'){
                this.scorableCommentsData.attachname = this.fileHolder.name
            }
            
            var reader = new FileReader();

            reader.onloadend = () => {
                //var b64 = reader.result.replace(/^data:.+base64,/, '');
                var b64 = reader.result;
                if(sectionType == 'trainData'){
                  this.trainData.attach = b64
                } else if (sectionType == 'scorableCommentsData'){
                  this.scorableCommentsData.attach = b64
                }
            }

            reader.readAsDataURL(file);
          } else {
              if(sectionType == 'trainData'){
                this.trainData.attach = null
              } else if (sectionType == 'scorableCommentsData'){
                this.scorableCommentsData.attach = null
              }
          }
        },

    // //     openProgressReview() {
    // //         this.progreselfservicereviewdialog = true;
    // //     },

    // //     handleAddProgressReview(newData) {
    // //         this.progressReviewList.push(newData);
    // //         this.formData.progress = newData.progress; 
    // //     },

    // //     changeTargetOption(id, selection) {
    // //         let item = this.targetOptionFull.find((item) => item.id === id);
    // //         if (selection == 1) {
    // //             this.formData.targetType = item.targetoption;
    // //         } else if (selection == 2) {
    // //             this.selections.targetType = item.targetoption;
    // //         }
    // //         if (id == 1) //Target only
    // //         {
    // //             this.selections.threshold = null;
    // //             this.selections.stretch = null;
    // //         }
    // //     },

    // //    modifyItemHandler() {
    // //         this.commentsDialog = true;
    // //     },

        saveHandler() {
            const vm = this;
            console.log("COMMENTSDATA", vm.commentsData);
            if(this.formData.sectionname == 'Comments'){
                if(this.isEditComments){ //EDIT
                    this.$store.dispatch('put', {url: "/reviewformsectiond/item/" + vm.commentsData.id, payload: vm.commentsData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            const itemToUpdate = vm.itemChildList.find(item => item.id === vm.commentsData.id);
                            if (itemToUpdate) {
                                itemToUpdate.comment = vm.commentsData.comment;
                            }
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }else{ //ADD
                    this.$store.dispatch('post', {url: "/reviewformsectiond/item/create", payload: vm.commentsData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            // Add the new comment to itemChildList
                            const newItem = res.data.result;
                            if (newItem) {
                                this.itemChildList = [...this.itemChildList, newItem];
                                this.assignStaffDetailsToItems(); // Assign staff details to the new item
                            }
                            
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }
            }else if(this.formData.sectionname == 'Movement Recommendations'){
                if(this.isEditComments){ //EDIT
                    this.$store.dispatch('put', {url: "/reviewformsectiond/item/" + vm.movData.id, payload: vm.movData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            const itemToUpdate = vm.itemChildList.find(item => item.id === vm.movData.id);
                            if (itemToUpdate) {
                                itemToUpdate.justification = vm.movData.justification;
                            }
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }else{ //ADD
                    this.$store.dispatch('post', {url: "/reviewformsectiond/item/create", payload: vm.movData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            // Add the new comment to itemChildList
                            const newItem = res.data.result;
                            if (newItem) {
                                this.itemChildList = [...this.itemChildList, newItem];
                            }
                            
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }
            }else if(this.formData.sectionname == 'Training Recommendations'){
                console.log("TRAINING", this.trainData);
                if(this.isEditComments){ //EDIT
                    this.$store.dispatch('put', {url: "/reviewformsectiond/item/" + vm.trainData.id, payload: vm.trainData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            const itemToUpdate = vm.itemChildList.find(item => item.id === vm.trainData.id);
                            if (itemToUpdate) {
                                itemToUpdate.priority = vm.trainData.priority;
                                itemToUpdate.justification = vm.trainData.justification;
                                itemToUpdate.remark = vm.trainData.remark;  
                                itemToUpdate.attach = vm.trainData.attach;
                                itemToUpdate.attachname = vm.trainData.attachname;
                            }
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }else{ //ADD
                    this.$store.dispatch('post', {url: "/reviewformsectiond/item/create", payload: vm.trainData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            // Add the new comment to itemChildList
                            const newItem = res.data.result;
                            if (newItem) {
                                this.itemChildList = [...this.itemChildList, newItem];
                            }
                            
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }
            }else if (this.formData.sectionname == 'Scorable Section'){
                if(this.isEditComments){ //EDIT
                    this.$store.dispatch('put', {url: "/reviewformsectiond/item/" + vm.scorableCommentsData.id, payload: vm.scorableCommentsData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            const itemToUpdate = vm.itemChildList.find(item => item.id === vm.scorableCommentsData.id);
                            if (itemToUpdate) {
                                itemToUpdate.comment = vm.scorableCommentsData.comment;
                                itemToUpdate.attach = vm.scorableCommentsData.attach;
                                itemToUpdate.attachname = vm.scorableCommentsData.attachname;
                            }
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }else{ //ADD
                    this.$store.dispatch('post', {url: "/reviewformsectiond/item/create", payload: vm.scorableCommentsData})
                    .then((res) => {
                        if (res.data.error) {
                            vm.isErr = true;
                            if (Array.isArray(res.data.error)) {
                                vm.errMsg = res.data.error.map((e, index) => `${index + 1}. ${e.msg}`).join('\n');
                            } else {
                                vm.errMsg = res.data.error;
                            }
                        } else {
                            // Add the new comment to itemChildList
                            const newItem = res.data.result;
                            if (newItem) {
                                this.itemChildList = [...this.itemChildList, newItem];
                                this.assignStaffDetailsToItems(); // Assign staff details to the new item
                            }
                            
                            this.commentsDialog = false;
                            this.resetSelections();
                        }
                    })
                    .catch((err) => {
                        vm.isErr = true;
                        vm.errMsg = err.message || err;
                    });
                }
            }
        },

    //     // assignSectionName(id) {
    //     //     const section = this.sectionTypeList.find(section => section.id === id);
    //     //     this.formData.sectionname = section ? section.description : null;
    //     //     this.loadingSection = false;
    //     // }

        cancelHandler() {
            this.commentsDialog = false;
            // this.isErr = false;
            // this.isExisting = false;
            // this.modify = false;

            // reset the form fields
            this.resetSelections();
        },

        resetSelections() {
            this.isEditComments = false;

            this.commentsData = {
                id: null,
                pmreviewformsectiondid: null,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                staffid: this.$store.getters.staffId,
                staffcode: null,
                staffcompany: null,
                comment: null,
                secttype: "Comments",
                stamp: 0,
                userid: this.$store.getters.userId,
            };

            this.scorableCommentsData = {
                id: null,
                pmreviewformsectiondid: null,
                pmreviewstaffreviewerid: this.parentObject.review.reviewstaffreviewerid,
                staffid: this.$store.getters.staffId,
                staffcode: null,
                staffcompany: null,
                comment: null,
                attach: null,
                attachname: null,
                secttype: "Scorable Section",
                stamp: 0,
                userid: this.$store.getters.userId,
            };
        }
    
    },

    async mounted() {
        try {
            console.log("PARENTOBJECT", this.parentObject);
            await this.loadRatingSetDetails();
            if(this.formData.sectionname == 'Objective'){
                await this.loadIndKPI();
                await this.loadCommonKPI();
                await this.processIndKPIList();
                await this.loadINDKPIFinalRatings();
                await this.calculateObjectiveSectionScore();
            }
            await this.loadStaff();
            await this.loadSectionItems();
            if (this.formData.sectionname == 'Scorable Section') {
                await this.loadItemChildScorable();
            }
            if (this.formData.sectionname == 'Comments' || this.formData.sectionname == 'Training Recommendations' || this.formData.sectionname == 'Movement Recommendations' || this.formData.sectionname == 'Scorable Section') {
                await this.loadItemChild();
            }
            if (this.formData.sectionname == 'Comments' || this.formData.sectionname == 'Training Recommendations' || this.formData.sectionname == 'Movement Recommendations') {
                await this.getPriorityListHandler();
            }


        } catch (err) {
            console.error("Error loading in mounted:", err);
        }
    }
}
</script>

<style>
.v-expansion-panel-header .v-icon.mdi-chevron-down.theme--light {
    color: white !important;
}

.equal-height-card {
    min-height: 110px; /* Set a minimum height */
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}


</style>

<style scoped>
.mdi-delete::before {
    margin-top: -8px;
}

/* Force compact height on inner comment/child expansion panel headers */
::v-deep .v-expansion-panels .v-expansion-panels .v-expansion-panel-header {
    min-height: 36px !important;
    padding-top: 6px !important;
    padding-bottom: 6px !important;
}

.dialog-header {
    font-size: 0.95rem !important;
    font-weight: 700 !important;
    color: #1a3a5c !important;
    letter-spacing: normal !important;
    padding: 14px 20px 10px 20px !important;
    border-bottom: 1px solid #E8EDF5;
}

.item-stat-bar {
    display: flex;
    gap: 24px;
    justify-content: flex-end;
    background: #DBEAFE;
    border-radius: 8px;
    padding: 10px 16px;
    margin-top: 10px;
    margin-bottom: 6px;
}

.item-stat {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
}

.item-stat-label {
    font-size: 0.7rem;
    font-weight: 600;
    color: #546e7a;
    letter-spacing: normal;
    line-height: 1.2;
}

.item-stat-value {
    font-size: 1rem;
    font-weight: 700;
    color: #1a3a5c;
    letter-spacing: normal;
    line-height: 1.2;
}

.item-stat-value.highlight {
    color: #1a3a5c;
    background: #FFF3C4;
    border-radius: 4px;
    padding: 0 4px;
}


.section-header-inner {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding-right: 8px;
}

.section-title {
    font-size: 0.88rem;
    font-weight: 700;
    color: #1a3a5c;
    letter-spacing: normal;
}

.section-stats {
    display: flex;
    gap: 20px;
    align-items: center;
}

.stat-item {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.stat-label {
    font-size: 0.7rem;
    font-weight: 600;
    color: #546e7a;
    letter-spacing: normal;
    line-height: 1.2;
}

.stat-value {
    font-size: 1rem;
    font-weight: 700;
    color: #1a3a5c;
    letter-spacing: normal;
    line-height: 1.2;
}

.mdi-pen::before {
  margin-top: 10px;
}

.v-icon.v-icon::after {
    background-color: transparent !important;
}

</style>